import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

interface Coordinates {
  latitude: number | null
  longitude: number | null
}

interface LocationInfo {
  display_name: string
  address: {
    city?: string
    state?: string
    country?: string
  }
}

interface GeolocationState {
  coordinates: Coordinates
  locationInfo: LocationInfo | null
  error: string | null
  isLoading: boolean
  isModalOpen: boolean
  showFields: boolean
  localErrors: Record<string, string>
  previousUrl: string | null
  userManagementUrl:string | null
  mnoUrl:string | null
}

const initialState: GeolocationState = {
  coordinates: {
    latitude: null,
    longitude: null,
  },
  locationInfo: null,
  error: null,
  isLoading: false,
  isModalOpen: false,
  showFields: false,
  localErrors: {
    latitude: "",
    longitude: "",
  },
  previousUrl: null,
  userManagementUrl:null,
  mnoUrl:null
}

const geolocationSlice = createSlice({
  name: "geolocation",
  initialState,
  reducers: {
    setCoordinates: (state, action: PayloadAction<Coordinates>) => {
      state.coordinates = action.payload
    },
    setLocationInfo: (state, action: PayloadAction<LocationInfo | null>) => {
      state.locationInfo = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload
    },
    setShowFields: (state, action: PayloadAction<boolean>) => {
      state.showFields = action.payload
    },
    setLocalErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.localErrors = action.payload
    },
    setPreviousUrl: (state, action: PayloadAction<string | null>) => {
      state.previousUrl = action.payload
    },
    setUserUrl: (state, action: PayloadAction<string | null>) => {
      state.userManagementUrl = action.payload
    },
    setMnoUrl: (state, action: PayloadAction<string | null>) => {
      state.mnoUrl = action.payload
    },
    resetLocation:(state)=>{
      state.coordinates = {
        latitude: null,
        longitude: null,
      }
      state.locationInfo = null
      state.error = null
      state.isLoading = false
      state.isModalOpen = false
      state.showFields = false
      state.localErrors = {
        latitude: "",
        longitude: "",
      }
      state.previousUrl = null
    }
  },
})

export const {
  setCoordinates,
  setLocationInfo,
  setError,
  setIsLoading,
  setIsModalOpen,
  setShowFields,
  setLocalErrors,
  setPreviousUrl,
  setUserUrl,
  setMnoUrl,
  resetLocation
} = geolocationSlice.actions

export default geolocationSlice.reducer